import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import Vue from 'vue';
import Gikam from 'gikam';
import Router from 'vue-router';
import { init as initSunwayApm } from '@elastic/apm-rum';
Vue.use(Router);
var defaultOptions = {
  serviceName: null,
  serverUrl: '',
  serviceVersion: ''
};

var SunwayApmRum = /*#__PURE__*/function () {
  function SunwayApmRum() {
    _classCallCheck(this, SunwayApmRum);
  }

  _createClass(SunwayApmRum, null, [{
    key: "init",
    value: function init(options) {
      Gikam.extend(true, defaultOptions, options);
      var serviceName = defaultOptions.serviceName,
          serverUrl = defaultOptions.serverUrl,
          serviceVersion = defaultOptions.serviceVersion;

      if (serviceName && serverUrl) {
        initSunwayApm({
          serviceName: serviceName,
          serverUrl: serverUrl,
          serviceVersion: serviceVersion
        });
      }
    }
  }]);

  return SunwayApmRum;
}();

export { SunwayApmRum as default };